const facettedSearchWidget = require('../../_utilities/facettedsearchwidget');

(() => {
  const reducer = () => (state, action) => {
    switch (action.type) {
      case 'UPDATE':
        state = action.value;
        break;

      default:
        break;
    }

    return state;
  };

  window.swinger.app({
    type: 'performers',
    component: 'performers',
    reducer: reducer(),
  })
    .then(facettedSearchWidget('performers'))
    .catch(console.info);
})();



// WEBPACK FOOTER //
// ./src/widgets/performers/performers.js